import '$lib/ui/install/service-worker-handler';

export const prerender = true;
export const trailingSlash = 'always';
